<template>
  <div>
    <div class="row mt-4">
      <div class="col-md-5">
        <h1 class="h3">
          {{ $t('product.productTags.title') }}
        </h1>
      </div>
      <div class="col-md-3 p-0" />
      <div class="col-md-4 text-right">
        <a-button
          type="primary"
          size="large"
          @click="onShowModal(null)"
        >
          {{ $t('product.productTags.add_new') }}
        </a-button>
      </div>
    </div>
    <div class="mt-4">
      <a-tabs class="pca-tab-product" @change="onTabChange">
        <a-tab-pane key="all" :tab="$t('product.productTags.tabs.all')" />
        <a-tab-pane key="active" :tab="$t('product.productTags.tabs.active')" />
        <a-tab-pane key="inactive" :tab="$t('product.productTags.tabs.inactive')" />
      </a-tabs>
      <a-table
        class="product-list mt-3 mb-2 bg-white"
        :data-source="filteredItems"
        :row-key="(record) => record.channel_product_tag.id"
        :columns="columns"
        :loading="isLoading"
        :pagination="pagination"
        @change="onTableChange"
      >
        <template slot="name" slot-scope="text">
          <b style="color: #2196F3">
            {{ text || '-' }}
          </b>
        </template>
        <template slot="status" slot-scope="text">
          <a-tag :color="text ? 'green' : 'red'">
            {{ text ? $t('product.productTags.tabs.active') : $t('product.productTags.tabs.inactive') }}
          </a-tag>
        </template>
        <template slot="action" slot-scope="record">
          <div class="text-right">
            <a-dropdown>
              <a @click.prevent="">
                <a-icon type="more" />
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item key="deactivate" @click="onDeactivate(record)">
                    {{ record.channel_product_tag.is_display ? $t('product.productTags.action.deactivate') : $t('product.productTags.action.activate') }}
                  </a-menu-item>
                  <a-menu-item key="details" @click="onSeeDetails(record)">
                    {{ $t('product.productTags.action.see_details') }}
                  </a-menu-item>
                  <a-menu-item key="edit" @click="onShowModal(record)">
                    {{ $t('product.productTags.action.edit') }}
                  </a-menu-item>
                  <a-menu-item key="manage" @click="onManageProducts(record)">
                    {{ $t('product.productTags.action.manage_products') }}
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </template>
      </a-table>
    </div>


    <a-modal
      v-model="onShow"
      :footer="null"
      :destroy-on-close="true"
      width="600px"
    >
      <template slot="title">
        <div class="d-flex align-items-center">
          <div class="bg-rose-50 p-2 rounded mr-3" style="background-color: #fff1f2;">
            <a-icon type="tag" style="color: #f43f5e;" />
          </div>
          <div>
            <h2 class="h5 mb-0 font-weight-bold">
              {{ edit ? $t('product.productTags.modal.edit_title') : $t('product.productTags.modal.add_title') }}
            </h2>
            <p class="text-muted small mb-0">
              {{ $t('product.productTags.modal.subtitle') }}
            </p>
          </div>
        </div>
      </template>

      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        layout="vertical"
      >
        <div class="mb-4">
          <p class="text-uppercase small font-weight-bold text-muted mb-2" style="letter-spacing: 0.05em;">
            {{ $t('product.productTags.modal.field_name') }}
          </p>
          <div class="border rounded overflow-hidden">
            <div v-for="lang in LANGS" :key="lang.key" class="d-flex align-items-center p-0 border-bottom last-border-0" style="transition: background-color 0.3s;">
              <div class="px-3 py-3 border-right text-center" style="width: 100px; background-color: #f8fafc;">
                <div class="font-weight-bold small text-dark">
                  {{ lang.flag }} {{ lang.short }}
                </div>
                <div class="text-muted" style="font-size: 10px;">
                  {{ lang.required ? $t('product.productTags.modal.required') : $t('product.productTags.modal.optional') }}
                </div>
              </div>


              <div class="flex-grow-1">
                <a-input
                  v-model="form[lang.key]"
                  :placeholder="lang.placeholder"
                  class="border-0 shadow-none modal-input-custom"
                  size="large"
                />
              </div>


              <div class="px-3 py-3 d-flex align-items-center">
                <a-button
                  size="small"
                  :type="form.default_lang === lang.key ? 'primary' : 'default'"
                  shape="round"
                  class="btn-default-lang"
                  @click="onChangeDefaultLang(lang)"
                >
                  <a-icon v-if="form.default_lang === lang.key" type="check" />
                  {{ form.default_lang === lang.key ? $t('product.productTags.modal.default') : $t('product.productTags.modal.set_as_default') }}
                </a-button>
              </div>
            </div>
          </div>
        </div>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item prop="sequence">
              <template slot="label">
                <span class="text-uppercase small font-weight-bold text-muted" style="letter-spacing: 0.05em;">
                  <a-icon type="number" class="mr-1" /> {{ $t('product.productTags.modal.sequence') }}
                </span>
              </template>
              <a-input-number
                v-model="form.sequence"
                size="large"
                :min="1"
                style="width: 100%"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="is_display">
              <template slot="label">
                <span class="text-uppercase small font-weight-bold text-muted" style="letter-spacing: 0.05em;">
                  <a-icon type=" eye" class="mr-1" /> {{ $t('product.productTags.modal.status') }}
                </span>
              </template>
              <a-select v-model="form.is_display" size="large">
                <a-select-option :value="true">
                  {{ $t('product.productTags.tabs.active') }}
                </a-select-option>
                <a-select-option :value="false">
                  {{ $t('product.productTags.tabs.inactive') }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <div class="mt-4 pt-3 border-top d-flex">
          <a-button
            size="large"
            class="flex-grow-1 mr-2 rounded-lg"
            @click="onShow = false"
          >
            {{ $t('product.productTags.modal.cancel') }}
          </a-button>
          <a-button
            type="primary"
            size="large"
            class="flex-grow-1 rounded-lg"
            @click="onSubmit"
          >
            <a-icon type="check" /> {{ $t('product.productTags.modal.submit') }}
          </a-button>
        </div>
      </a-form-model>
    </a-modal>


    <a-modal
      v-model="showDetail"
      :title="$t('product.productTags.detail.title')"
      :footer="null"
      :destroy-on-close="true"
      width="600px"
    >
      <div v-if="detailData">
        <div class="row">
          <div class="col-md-4 font-weight-bold">
            {{ $t('product.productTags.detail.id') }}:
          </div>
          <div class="col-md-8">
            {{ detailData.id || '-' }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4 font-weight-bold">
            {{ $t('product.productTags.detail.name_id') }}:
          </div>
          <div class="col-md-8">
            {{ detailData.name || '-' }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4 font-weight-bold">
            {{ $t('product.productTags.detail.name_en') }}:
          </div>
          <div class="col-md-8">
            {{ detailData.channel_product_tag_languages?.find(l => l.language === 'en')?.name || '-' }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4 font-weight-bold">
            {{ $t('product.productTags.modal.sequence') }}:
          </div>
          <div class="col-md-8">
            {{ detailData.sequence || '-' }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4 font-weight-bold">
            {{ $t('product.productTags.modal.status') }}:
          </div>
          <div class="col-md-8">
            <a-tag :color="detailData.is_display ? 'green' : 'red'">
              {{ detailData.is_display ? $t('product.productTags.tabs.active') : $t('product.productTags.tabs.inactive') }}
            </a-tag>
          </div>
        </div>
      </div>
      <div v-else class="text-center py-4">
        <a-spin />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getTags, createTag, updateTag, getTagDetail } from '@/api/product-tags'

const LANGS = [
  { key: 'id', flag: '🇮🇩', label: 'Bahasa Indonesia', short: 'ID', placeholder: 'Masukkan nama tag...', dir: 'ltr', required: true },
  { key: 'en', flag: '🇺🇸', label: 'English', short: 'EN', placeholder: 'Enter tag name...', dir: 'ltr', required: true },
]

export default {
  name: 'ProductTags',
  data() {
    return {
      LANGS,
      keyword: '',
      isLoading: false,
      active_only: undefined,
      onShow: false,
      showDetail: false,
      detailData: null,
      edit: false,
      items: [],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      form: {
        tag_id: null,
        id: '',
        en: '',
        is_display: true,
        sequence: 1,
        default_lang: 'id',
      },
      rules: {
        id: [{ required: true, message: this.$t('product.productTags.messages.id_required'), trigger: 'blur' }],
        en: [{ required: true, message: this.$t('product.productTags.messages.en_required'), trigger: 'blur' }],
      },
    }
  },
  computed: {
    filteredItems() {
      return this.items
    },
    columns() {
      return [
        {
          title: this.$t('product.productTags.table.name'),
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: this.$t('product.productTags.table.status'),
          dataIndex: 'channel_product_tag.is_display',
          key: 'is_display',
          width: 150,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '',
          key: 'action',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    locale() {
      return this.$store.state.settings.locale
    },
  },
  watch: {
    locale() {
      this.fetchData()
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
     async fetchData() {
       this.isLoading = true
       try {
         const params = {
           active_only: this.active_only,
           page: this.pagination.current,
           size: this.pagination.pageSize,
           sort: 'asc',
           order_by: 'channelProductTag.sequence',
         }
         const { data } = await getTags(this.$route.params.id, params)
         this.items = data.content || []
         this.pagination.total = data.total_elements || 0
       } catch (error) {
         this.$message.error(this.$t('product.productTags.messages.fetch_failed'))
       } finally {
         this.isLoading = false
       }
     },
     onTableChange(pagination) {
       this.pagination.current = pagination.current
       this.fetchData()
     },
     onTabChange(key) {
       this.active_only = key === 'active' ? true : key === 'inactive' ? false : undefined
       this.pagination.current = 1
       this.fetchData()
     },
     onSearch() {
       this.pagination.current = 1
       this.fetchData()
     },
     async onShowModal(record) {
       if (record) {
         this.edit = true
         this.isLoading = true
         try {
           const { data: response } = await getTagDetail(this.$route.params.id, record.channel_product_tag.id)
           const detail = response.data || response
           
           this.form = {
             tag_id: detail.id,
             id: detail.channel_product_tag_languages?.find(l => l.language === 'id')?.name || detail.name,
             en: detail.channel_product_tag_languages?.find(l => l.language === 'en')?.name || '',
             is_display: detail.is_display,
             sequence: detail.sequence || 1,
             default_lang: detail.channel_product_tag_languages?.find(l => l.is_default)?.language || 'id',
           }
           this.onShow = true
         } catch (error) {
           this.$message.error(this.$t('product.productTags.messages.fetch_detail_failed'))
         } finally {
           this.isLoading = false
         }
       } else {
         this.edit = false
         this.form = { tag_id: null, id: '', en: '', is_display: true, sequence: 1, default_lang: 'id' }
         this.onShow = true
       }
     },
     onSubmit() {
       this.$refs.ruleForm.validate(async valid => {
         if (valid) {
           const payload = {
             name: this.form.id,
             is_display: this.form.is_display,
             sequence: parseInt(this.form.sequence),
             channel_product_tag_languages: [
               {
                 language: 'id',
                 name: this.form.id,
                 is_default: this.form.default_lang === 'id',
               },
               {
                 language: 'en',
                 name: this.form.en,
                 is_default: this.form.default_lang === 'en',
               },
             ],
           }

           try {
             if (this.edit) {
               await updateTag(this.$route.params.id, this.form.tag_id, payload)
             } else {
               await createTag(this.$route.params.id, payload)
             }
             this.onShow = false
             this.$message.success(this.$t('product.productTags.messages.save_success'))
             this.fetchData()
           } catch (error) {
             this.$message.error(this.$t('product.productTags.messages.save_failed'))
           }
         }
       })
     },
     onChangeDefaultLang(lang) {
       this.form.default_lang = lang.key
       this.$message.destroy()
       this.$message.success(this.$t('product.productTags.messages.set_default_success', { lang: lang.label }))
     },
     async onDeactivate(record) {
       const newStatus = !record.is_display
       try {
         const { data: response } = await getTagDetail(this.$route.params.id, record.channel_product_tag.id)
         console.log('=>', response)
         const detail = response.data || response
         
         const payload = {
           name: detail.name,
           is_display: !detail.is_display,
           sequence: detail.sequence,
           channel_product_tag_languages: detail.channel_product_tag_languages || [],
         }
         
         await updateTag(this.$route.params.id, record.channel_product_tag.id, payload)
         this.$message.success(this.$t('product.productTags.messages.status_updated', { name: record.name }))
         this.fetchData()
       } catch (error) {
         this.$message.error(this.$t('product.productTags.messages.status_update_failed'))
       }
     },
     async onSeeDetails(record) {
       this.showDetail = true
       this.detailData = null
       try {
         const { data: response } = await getTagDetail(this.$route.params.id, record.channel_product_tag.id)
         this.detailData = response.data || response
       } catch (error) {
         this.$message.error(this.$t('product.productTags.messages.detail_fetch_failed'))
         this.showDetail = false
       }
     },
      onManageProducts(record) {
        this.$router.push({
          name: 'product-channel.manage-product-tags',
          params: {
            id: this.$route.params.id,
          },
          query: {
            ...this.$route.query,
            tag_id: record.channel_product_tag.id,
          },
        })
      },
    },
}
</script>

<style lang="scss" scoped>
.product-list {
  ::v-deep .ant-table-row {
    background-color: #fff !important;
  }
}

.pca-tab-product {
  ::v-deep {
    .ant-tabs-nav .ant-tabs-tab:hover,
    .ant-tabs-nav .ant-tabs-tab-active {
      color: #ff0a54;
    }

    .ant-tabs-ink-bar {
      background-color: #ff0a54;
    }
  }
}
.last-border-0:last-child {
  border-bottom: 0 !important;
}

.modal-input-custom {
  ::v-deep .ant-input {
    border: 0 !important;
    background: transparent !important;
    &:focus {
      box-shadow: none !important;
    }
  }
}

.btn-default-lang {
  &.ant-btn-primary {
    background-color: #f43f5e !important;
    border-color: #f43f5e !important;
  }
  &:not(.ant-btn-primary) {
    color: #cbd5e1 !important;
    border-color: #e2e8f0 !important;
    &:hover {
      color: #f43f5e !important;
      border-color: #fda4af !important;
    }
  }
}
</style>
